import { render, staticRenderFns } from "./VisitType.vue?vue&type=template&id=765522b5"
import script from "./VisitType.vue?vue&type=script&lang=js"
export * from "./VisitType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports